import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from './AppColors.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Semanticpmpmvt7fldq2 as Semantic,
  ButtonSemantic_getInstance2exl8jbak13ac as ButtonSemantic_getInstance,
  HoverSemantic_getInstance2nvjr5vpt4xe8 as HoverSemantic_getInstance,
  DownSemantic_getInstance12o2om5g6786l as DownSemantic_getInstance,
  WarningSemantic_getInstance2xxn62yaantj2 as WarningSemantic_getInstance,
  UnselectedSemantic_getInstancexnnq5hq6ryv2 as UnselectedSemantic_getInstance,
  SelectedSemantic_getInstance3ef29ujazc52t as SelectedSemantic_getInstance,
  DisabledSemantic_getInstanceimdypc22j9b3 as DisabledSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  Companion_getInstancenv8qpb0wanrh as Companion_getInstance,
  applyAlpha3k2fcxahu1lgz as applyAlpha,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Paint.mjs';
import {
  get_dp28ag147e4p5cz as get_dp,
  get_px8ok5q0jdway2 as get_px,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mapOf1xd03cq9cnmy8 as mapOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../components/nav/AppDimensions.mjs';
import { mapOf2zpbbmyqk8xpf as mapOf_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { ForegroundSemantic2og103ajpnjfv as ForegroundSemantic } from './colorManagement.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance_0,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MILLISECONDS_getInstance15owevua4zjxe as DurationUnit_MILLISECONDS_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  get_centered1xfu6or5nc0lq as get_centered,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { space2ppi73m2qk1br as space } from '../components/space.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  body3i5t0n7zprpqb as body,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
} from './Titles.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  SizeConstraints24axz83pb17aw as SizeConstraints,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  get_viewIsNarrow26l63sh4olw2h as get_viewIsNarrow,
  get_windowIsNarrow3aab1t9rdaelq as get_windowIsNarrow,
} from '../components/nav/crowpay.mjs';
import { changingSizeConstraints2ompnjjk125zt as changingSizeConstraints } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { shownDefaultFalse3hpz4awymyomc as shownDefaultFalse } from '../../utils/utils.mjs';
import { unreadIconWhen1430ixd91bo9h as unreadIconWhen } from '../components/iconShortcuts.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance_1 } from '../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { matchAlphaf1v7f410jfqp as matchAlpha } from './appTheme.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function PrimaryButtonSemantic$default$lambda($this$to, it) {
  return $this$to.hd1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, AppColors_getInstance().lfz_1);
}
function PrimaryButtonSemantic$default$lambda_0($this$to, it) {
  return $this$to.hd1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, AppColors_getInstance().dfz_1.wg9_1);
}
var PrimaryButtonSemanticClass;
function PrimaryButtonSemantic() {
  if (PrimaryButtonSemanticClass === VOID) {
    class $ extends Semantic() {
      static jjq() {
        PrimaryButtonSemantic_instance = null;
        var $this = this.bd1('priBtn');
        PrimaryButtonSemantic_instance = $this;
        return $this;
      }
      cd1(theme) {
        var tmp0_$receiver = theme.db1(ButtonSemantic_getInstance()).eb1_1;
        var tmp1_background = AppColors_getInstance().dfz_1.xg9_1;
        var tmp2_foreground = Companion_getInstance().raz_1;
        var tmp3_outlineWidth = get_dp(0);
        var tmp = HoverSemantic_getInstance();
        var tmp_0 = to(tmp, PrimaryButtonSemantic$default$lambda);
        var tmp_1 = DownSemantic_getInstance();
        var tmp4_derivations = mapOf([tmp_0, to(tmp_1, PrimaryButtonSemantic$default$lambda_0)]);
        return this.hd1(tmp0_$receiver, VOID, VOID, VOID, VOID, VOID, VOID, tmp2_foreground, VOID, VOID, tmp3_outlineWidth, VOID, tmp1_background, VOID, VOID, VOID, VOID, VOID, tmp4_derivations);
      }
      toString() {
        return 'PrimaryButtonSemantic';
      }
      hashCode() {
        return 1242169544;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PrimaryButtonSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'PrimaryButtonSemantic');
    PrimaryButtonSemanticClass = $;
  }
  return PrimaryButtonSemanticClass;
}
var PrimaryButtonSemantic_instance;
function PrimaryButtonSemantic_getInstance() {
  if (PrimaryButtonSemantic_instance === VOID)
    PrimaryButtonSemantic().jjq();
  return PrimaryButtonSemantic_instance;
}
function get_primaryButton(_this__u8e3s4) {
  return _this__u8e3s4.hbb(PrimaryButtonSemantic_getInstance());
}
var SecondaryButtonSemanticClass;
function SecondaryButtonSemantic() {
  if (SecondaryButtonSemanticClass === VOID) {
    class $ extends Semantic() {
      static ljq() {
        SecondaryButtonSemantic_instance = null;
        var $this = this.bd1('secBtn');
        SecondaryButtonSemantic_instance = $this;
        return $this;
      }
      cd1(theme) {
        var backIsDark = theme.ob0_1.bb2().pcz().ycz_1 < 0.95;
        var tmp0_$receiver = theme.db1(ButtonSemantic_getInstance()).eb1_1;
        var tmp1_background = backIsDark ? AppColors_getInstance().ffz_1.aga_1 : AppColors_getInstance().ffz_1.zg9_1;
        var tmp2_foreground = Companion_getInstance().taz_1;
        var tmp = HoverSemantic_getInstance();
        var tmp_0 = to(tmp, ($this$to, it) => $this$to.hd1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, backIsDark ? AppColors_getInstance().ffz_1.zg9_1 : AppColors_getInstance().ffz_1.yg9_1));
        var tmp_1 = DownSemantic_getInstance();
        var tmp3_derivations = mapOf([tmp_0, to(tmp_1, ($this$to, it) => $this$to.hd1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, backIsDark ? AppColors_getInstance().ffz_1.yg9_1 : AppColors_getInstance().ffz_1.xg9_1))]);
        return this.hd1(tmp0_$receiver, VOID, VOID, VOID, VOID, VOID, VOID, tmp2_foreground, VOID, VOID, VOID, VOID, tmp1_background, VOID, VOID, VOID, VOID, VOID, tmp3_derivations);
      }
    }
    initMetadataForObject($, 'SecondaryButtonSemantic');
    SecondaryButtonSemanticClass = $;
  }
  return SecondaryButtonSemanticClass;
}
var SecondaryButtonSemantic_instance;
function SecondaryButtonSemantic_getInstance() {
  if (SecondaryButtonSemantic_instance === VOID)
    SecondaryButtonSemantic().ljq();
  return SecondaryButtonSemantic_instance;
}
function get_secondaryButton(_this__u8e3s4) {
  return _this__u8e3s4.hbb(SecondaryButtonSemantic_getInstance());
}
var TertiaryButtonSemanticClass;
function TertiaryButtonSemantic() {
  if (TertiaryButtonSemanticClass === VOID) {
    class $ extends Semantic() {
      static njq() {
        TertiaryButtonSemantic_instance = null;
        var $this = this.bd1('terBtn');
        TertiaryButtonSemantic_instance = $this;
        return $this;
      }
      cd1(theme) {
        return this.hd1(theme.db1(ButtonSemantic_getInstance()).eb1_1, VOID, VOID, VOID, VOID, VOID, VOID, AppColors_getInstance().cfz_1.xg9_1, VOID, AppColors_getInstance().cfz_1.xg9_1, get_AppDimensions().og2_1);
      }
      toString() {
        return 'TertiaryButtonSemantic';
      }
      hashCode() {
        return -1403667780;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof TertiaryButtonSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'TertiaryButtonSemantic');
    TertiaryButtonSemanticClass = $;
  }
  return TertiaryButtonSemanticClass;
}
var TertiaryButtonSemantic_instance;
function TertiaryButtonSemantic_getInstance() {
  if (TertiaryButtonSemantic_instance === VOID)
    TertiaryButtonSemantic().njq();
  return TertiaryButtonSemantic_instance;
}
function get_tertiaryButton(_this__u8e3s4) {
  return _this__u8e3s4.hbb(TertiaryButtonSemantic_getInstance());
}
var DangerButtonSemanticClass;
function DangerButtonSemantic() {
  if (DangerButtonSemanticClass === VOID) {
    class $ extends Semantic() {
      static pjq() {
        DangerButtonSemantic_instance = null;
        var $this = this.bd1('wrnBtn');
        DangerButtonSemantic_instance = $this;
        return $this;
      }
      cd1(theme) {
        var tmp0_$receiver = theme.db1(ButtonSemantic_getInstance()).eb1_1;
        var tmp1_background = AppColors_getInstance().hfz_1.xg9_1;
        var tmp2_foreground = Companion_getInstance().raz_1;
        return this.hd1(tmp0_$receiver, VOID, VOID, VOID, VOID, VOID, VOID, tmp2_foreground, VOID, VOID, VOID, VOID, tmp1_background);
      }
      toString() {
        return 'DangerButtonSemantic';
      }
      hashCode() {
        return -1644967091;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DangerButtonSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'DangerButtonSemantic');
    DangerButtonSemanticClass = $;
  }
  return DangerButtonSemanticClass;
}
var DangerButtonSemantic_instance;
function DangerButtonSemantic_getInstance() {
  if (DangerButtonSemantic_instance === VOID)
    DangerButtonSemantic().pjq();
  return DangerButtonSemantic_instance;
}
function get_dangerButton(_this__u8e3s4) {
  return _this__u8e3s4.hbb(DangerButtonSemantic_getInstance());
}
function WarningButtonSemantic() {
  return ButtonSemantic_getInstance().ybe(WarningSemantic_getInstance());
}
function TextButtonSemantic$default$lambda($this$to, it) {
  return $this$to.ed1(it, VOID, it.eb0_1.dd1(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, true));
}
var TextButtonSemanticClass;
function TextButtonSemantic() {
  if (TextButtonSemanticClass === VOID) {
    class $ extends Semantic() {
      static rjq() {
        TextButtonSemantic_instance = null;
        var $this = this.bd1('txtBtn');
        TextButtonSemantic_instance = $this;
        return $this;
      }
      cd1(theme) {
        var tmp = theme.db1(ButtonSemantic_getInstance()).eb1_1;
        var tmp_0 = Companion_getInstance().taz_1;
        var tmp_1 = get_dp(0);
        var tmp_2 = HoverSemantic_getInstance();
        return this.kd1(tmp, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, VOID, VOID, tmp_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, mapOf_0(to(tmp_2, TextButtonSemantic$default$lambda))).bb1_1;
      }
      toString() {
        return 'TextButtonSemantic';
      }
      hashCode() {
        return -1909979817;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof TextButtonSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'TextButtonSemantic');
    TextButtonSemanticClass = $;
  }
  return TextButtonSemanticClass;
}
var TextButtonSemantic_instance;
function TextButtonSemantic_getInstance() {
  if (TextButtonSemantic_instance === VOID)
    TextButtonSemantic().rjq();
  return TextButtonSemantic_instance;
}
function get_textButton(_this__u8e3s4) {
  return _this__u8e3s4.hbb(TextButtonSemantic_getInstance());
}
function get_warningTextButton(_this__u8e3s4) {
  return _this__u8e3s4.hbb(TextButtonSemantic_getInstance().ybe(ForegroundSemantic().agi(AppColors_getInstance().hfz_1.xg9_1)));
}
function DeleteButtonSemantic$default$lambda($this$to, it) {
  var tmp0_foreground = AppColors_getInstance().hfz_1.xg9_1;
  var tmp1_font = it.eb0_1.dd1(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, true);
  return $this$to.ed1(it, VOID, tmp1_font, VOID, VOID, VOID, VOID, tmp0_foreground);
}
var DeleteButtonSemanticClass;
function DeleteButtonSemantic() {
  if (DeleteButtonSemanticClass === VOID) {
    class $ extends Semantic() {
      static tjq() {
        DeleteButtonSemantic_instance = null;
        var $this = this.bd1('dltBtn');
        DeleteButtonSemantic_instance = $this;
        return $this;
      }
      cd1(theme) {
        var tmp = theme.db1(TextButtonSemantic_getInstance()).eb1_1;
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance_0();
        var tmp_0 = toDuration(100, DurationUnit_MILLISECONDS_getInstance());
        var tmp_1 = HoverSemantic_getInstance();
        return this.ed1(tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, mapOf_0(to(tmp_1, DeleteButtonSemantic$default$lambda)));
      }
      toString() {
        return 'DeleteButtonSemantic';
      }
      hashCode() {
        return 1368222933;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DeleteButtonSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'DeleteButtonSemantic');
    DeleteButtonSemanticClass = $;
  }
  return DeleteButtonSemanticClass;
}
var DeleteButtonSemantic_instance;
function DeleteButtonSemantic_getInstance() {
  if (DeleteButtonSemantic_instance === VOID)
    DeleteButtonSemantic().tjq();
  return DeleteButtonSemantic_instance;
}
function get_deleteButton(_this__u8e3s4) {
  return _this__u8e3s4.hbb(DeleteButtonSemantic_getInstance());
}
function ExpandButtonSemantic$default$lambda($this$to, it) {
  return $this$to.hd1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, AppColors_getInstance().ffz_1.zg9_1);
}
function ExpandButtonSemantic$default$lambda_0($this$to, it) {
  return $this$to.hd1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, AppColors_getInstance().ffz_1.yg9_1);
}
var ExpandButtonSemanticClass;
function ExpandButtonSemantic() {
  if (ExpandButtonSemanticClass === VOID) {
    class $ extends Semantic() {
      static vjq() {
        ExpandButtonSemantic_instance = null;
        var $this = this.bd1('expdBtn');
        ExpandButtonSemantic_instance = $this;
        return $this;
      }
      cd1(theme) {
        var tmp = theme.db1(ButtonSemantic_getInstance()).eb1_1;
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance_0();
        var tmp_0 = toDuration(100, DurationUnit_MILLISECONDS_getInstance());
        var tmp_1 = HoverSemantic_getInstance();
        var tmp_2 = to(tmp_1, ExpandButtonSemantic$default$lambda);
        var tmp_3 = DownSemantic_getInstance();
        return this.ed1(tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, mapOf([tmp_2, to(tmp_3, ExpandButtonSemantic$default$lambda_0)]));
      }
      toString() {
        return 'ExpandButtonSemantic';
      }
      hashCode() {
        return -1456605308;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ExpandButtonSemantic()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'ExpandButtonSemantic');
    ExpandButtonSemanticClass = $;
  }
  return ExpandButtonSemanticClass;
}
var ExpandButtonSemantic_instance;
function ExpandButtonSemantic_getInstance() {
  if (ExpandButtonSemantic_instance === VOID)
    ExpandButtonSemantic().vjq();
  return ExpandButtonSemantic_instance;
}
function get_expandButtonTheme(_this__u8e3s4) {
  return _this__u8e3s4.hbb(ExpandButtonSemantic_getInstance());
}
function RemoveToggleSemantic$default$lambda($this$to, it) {
  return it.ab1_1;
}
function RemoveToggleSemantic$default$lambda_0($this$to, it) {
  return it.ab1_1;
}
function RemoveToggleSemantic$default$lambda_1($this$to, it) {
  return it.ab1_1;
}
function RemoveToggleSemantic$default$lambda_2($this$to, it) {
  return it.ab1_1;
}
function RemoveToggleSemantic$default$lambda_3($this$to, it) {
  return $this$to.ed1(it, VOID, VOID, VOID, VOID, VOID, VOID, applyAlpha(it.jb0_1, 0.25), VOID, applyAlpha(it.lb0_1, 0.25));
}
var RemoveToggleSemanticClass;
function RemoveToggleSemantic() {
  if (RemoveToggleSemanticClass === VOID) {
    class $ extends Semantic() {
      static xjq() {
        RemoveToggleSemantic_instance = null;
        var $this = this.bd1('rmvtgl');
        RemoveToggleSemantic_instance = $this;
        return $this;
      }
      cd1(theme) {
        var tmp = HoverSemantic_getInstance();
        var tmp_0 = to(tmp, RemoveToggleSemantic$default$lambda);
        var tmp_1 = UnselectedSemantic_getInstance();
        var tmp_2 = to(tmp_1, RemoveToggleSemantic$default$lambda_0);
        var tmp_3 = SelectedSemantic_getInstance();
        var tmp_4 = to(tmp_3, RemoveToggleSemantic$default$lambda_1);
        var tmp_5 = DownSemantic_getInstance();
        var tmp_6 = to(tmp_5, RemoveToggleSemantic$default$lambda_2);
        var tmp_7 = DisabledSemantic_getInstance();
        return this.ed1(theme, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, mapOf([tmp_0, tmp_2, tmp_4, tmp_6, to(tmp_7, RemoveToggleSemantic$default$lambda_3)]));
      }
    }
    initMetadataForObject($, 'RemoveToggleSemantic');
    RemoveToggleSemanticClass = $;
  }
  return RemoveToggleSemanticClass;
}
var RemoveToggleSemantic_instance;
function RemoveToggleSemantic_getInstance() {
  if (RemoveToggleSemantic_instance === VOID)
    RemoveToggleSemantic().xjq();
  return RemoveToggleSemantic_instance;
}
function specCenteredText(_this__u8e3s4, content) {
  var tmp = sizeConstraints(_this__u8e3s4, get_AppDimensions().lg2_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(false);
  view.zb8(get_px(0));
  view.jbb(get_expanding(view), space(view, get_AppDimensions().kg2_1));
  view.jbb(get_centered(view), body(view, content));
  view.jbb(get_expanding(view), space(view, get_AppDimensions().kg2_1));
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp, view);
}
function specCenteredText_0(_this__u8e3s4, message) {
  var tmp = sizeConstraints(_this__u8e3s4, get_AppDimensions().lg2_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(false);
  view.zb8(get_px(0));
  view.jbb(get_expanding(view), space(view, get_AppDimensions().kg2_1));
  var tmp_0 = get_centered(view);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.jba(view_0.ob6_1.ybe(BodySemantic_getInstance()));
  var tmp_1 = KMutableProperty0();
  var tmp_2 = TextView$_get_content_$ref_4pzcwl(view_0);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_1, tmp_2, TextView$_set_content_$ref_pketfb(view_0));
  var actionToCalculate = message;
  reactiveScope(view_0, ($this$reactiveScope) => {
    this_0.set(actionToCalculate($this$reactiveScope));
    return Unit_instance;
  });
  view.fbb(p_0, view_0);
  view.jbb(tmp_0, view_0);
  view.jbb(get_expanding(view), space(view, get_AppDimensions().kg2_1));
  _this__u8e3s4.fbb(p, view);
  _this__u8e3s4.jbb(tmp, view);
}
function maybeSpecCenteredText(_this__u8e3s4, message) {
  var tmp;
  if (get_viewIsNarrow(_this__u8e3s4)) {
    var tmp_0 = get_centered(_this__u8e3s4);
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (TextView())(_this__u8e3s4.pc());
    var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
    var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
    _this__u8e3s4.ebb(p, view);
    view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
    view.bbs(Align_Center_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp_1 = view.tb5_1;
    var tmp_2;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(message) === 0) {
      tmp_2 = '\xA0';
    } else {
      tmp_2 = message;
    }
    tmp_1.fbu(tmp_2);
    _this__u8e3s4.fbb(p, view);
    tmp = _this__u8e3s4.jbb(tmp_0, view);
  } else {
    tmp = specCenteredText(_this__u8e3s4, message);
  }
  return tmp;
}
function maybeSpecCenteredText_0(_this__u8e3s4, message) {
  var tmp;
  if (get_viewIsNarrow(_this__u8e3s4)) {
    var tmp_0 = get_centered(_this__u8e3s4);
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (TextView())(_this__u8e3s4.pc());
    var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
    var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
    _this__u8e3s4.ebb(p, view);
    view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
    view.bbs(Align_Center_getInstance());
    var tmp_1 = KMutableProperty0();
    var tmp_2 = TextView$_get_content_$ref_4pzcwl_0(view);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp_1, tmp_2, TextView$_set_content_$ref_pketfb_0(view));
    var actionToCalculate = message;
    reactiveScope(view, ($this$reactiveScope) => {
      this_0.set(actionToCalculate($this$reactiveScope));
      return Unit_instance;
    });
    _this__u8e3s4.fbb(p, view);
    tmp = _this__u8e3s4.jbb(tmp_0, view);
  } else {
    specCenteredText_0(_this__u8e3s4, message);
    tmp = Unit_instance;
  }
  return tmp;
}
function specCenteredContent(_this__u8e3s4, removeSpacesWhenNarrow, setup) {
  removeSpacesWhenNarrow = removeSpacesWhenNarrow === VOID ? false : removeSpacesWhenNarrow;
  if (removeSpacesWhenNarrow) {
    changingSizeConstraints(_this__u8e3s4, specCenteredContent$lambda);
  } else
    sizeConstraints(_this__u8e3s4, get_AppDimensions().lg2_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(false);
  view.zb8(get_px(0));
  var tmp = get_expanding(view);
  var tmp_0 = get_AppDimensions().kg2_1;
  view.jbb(tmp, space(view, tmp_0, ($this$space) => {
    var tmp;
    if (removeSpacesWhenNarrow) {
      shownDefaultFalse($this$space, specCenteredContent$lambda$lambda);
      tmp = Unit_instance;
    }
    return Unit_instance;
  }));
  setup(view);
  var tmp_1 = get_expanding(view);
  var tmp_2 = get_AppDimensions().kg2_1;
  view.jbb(tmp_1, space(view, tmp_2, ($this$space) => {
    var tmp;
    if (removeSpacesWhenNarrow) {
      shownDefaultFalse($this$space, specCenteredContent$lambda$lambda_0);
      tmp = Unit_instance;
    }
    return Unit_instance;
  }));
  _this__u8e3s4.fbb(p, view);
  return view;
}
function specCenteredTextWithUnread(_this__u8e3s4, content, unread) {
  return specCenteredContent(_this__u8e3s4, VOID, ($this$specCenteredContent) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$specCenteredContent.pc());
    var tmp0_elvis_lhs = $this$specCenteredContent.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$specCenteredContent : tmp0_elvis_lhs;
    $this$specCenteredContent.ebb(p, view);
    view.xbm(false);
    view.zb8(get_AppDimensions().mg2_1);
    get_centered(view);
    unreadIconWhen(view, ($this$unreadIconWhen) => {
      // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
      return unread($this$unreadIconWhen);
    });
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
    Companion_getInstance_1();
    view.jbb(get_centered(view), body(view, content));
    $this$specCenteredContent.fbb(p, view);
    return view;
  });
}
function textButton(_this__u8e3s4, content, setup) {
  var tmp = get_textButton(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  specCenteredText(view, content);
  setup(view);
  _this__u8e3s4.fbb(p, view);
  _this__u8e3s4.jbb(tmp, view);
}
var MessageButtonClass;
function MessageButton() {
  if (MessageButtonClass === VOID) {
    class $ extends Semantic() {
      static zjq() {
        MessageButton_instance = null;
        var $this = this.bd1('msgbtn');
        MessageButton_instance = $this;
        return $this;
      }
      cd1(theme) {
        var tmp0_$receiver = theme.db1(ButtonSemantic_getInstance()).eb1_1;
        var tmp1_background = matchAlpha(AppColors_getInstance().cfz_1.xg9_1, theme.ob0_1);
        var tmp2_foreground = matchAlpha(Companion_getInstance().raz_1, theme.jb0_1);
        return this.hd1(tmp0_$receiver, VOID, VOID, VOID, VOID, VOID, VOID, tmp2_foreground, VOID, VOID, VOID, VOID, tmp1_background);
      }
      toString() {
        return 'MessageButton';
      }
      hashCode() {
        return 1423821607;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MessageButton()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'MessageButton');
    MessageButtonClass = $;
  }
  return MessageButtonClass;
}
var MessageButton_instance;
function MessageButton_getInstance() {
  if (MessageButton_instance === VOID)
    MessageButton().zjq();
  return MessageButton_instance;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function specCenteredContent$lambda($this$changingSizeConstraints) {
  return $this$changingSizeConstraints.baj(get_windowIsNarrow()) ? new (SizeConstraints())() : new (SizeConstraints())(get_AppDimensions().lg2_1);
}
function specCenteredContent$lambda$lambda($this$shownDefaultFalse) {
  return !$this$shownDefaultFalse.baj(get_windowIsNarrow());
}
function specCenteredContent$lambda$lambda_0($this$shownDefaultFalse) {
  return !$this$shownDefaultFalse.baj(get_windowIsNarrow());
}
//region block: exports
export {
  WarningButtonSemantic as WarningButtonSemantice48d7oqt0xse,
  get_dangerButton as get_dangerButtonciwpmvl7jmt2,
  get_deleteButton as get_deleteButton1v46c8rhktdg5,
  get_expandButtonTheme as get_expandButtonTheme1dpdnzsv2lxs8,
  maybeSpecCenteredText as maybeSpecCenteredText3k2zk0rmdqomq,
  maybeSpecCenteredText_0 as maybeSpecCenteredText1iusdmvklvsob,
  get_primaryButton as get_primaryButton2lywrys4ffv1i,
  get_secondaryButton as get_secondaryButtondor94xxt3ws3,
  specCenteredContent as specCenteredContent3evlhhbrk2e00,
  specCenteredTextWithUnread as specCenteredTextWithUnread1yfsy2lami2hh,
  specCenteredText_0 as specCenteredText33v0vmsdeuehr,
  specCenteredText as specCenteredText1zemopd0g3rsf,
  get_tertiaryButton as get_tertiaryButton1h22y4lorv47t,
  get_textButton as get_textButtonybbt8y3eu5hx,
  textButton as textButton18d6zwa74vao7,
  get_warningTextButton as get_warningTextButton13ztryiioyzkv,
  DangerButtonSemantic_getInstance as DangerButtonSemantic_getInstanceb7gofax87736,
  DeleteButtonSemantic_getInstance as DeleteButtonSemantic_getInstance1x6fgyalib897,
  ExpandButtonSemantic_getInstance as ExpandButtonSemantic_getInstance3eedzzd1fkase,
  MessageButton_getInstance as MessageButton_getInstance33lwpvjn45jp0,
  PrimaryButtonSemantic_getInstance as PrimaryButtonSemantic_getInstance2oopjxbt9oc9b,
  RemoveToggleSemantic_getInstance as RemoveToggleSemantic_getInstancet61nqekdjv1v,
  SecondaryButtonSemantic_getInstance as SecondaryButtonSemantic_getInstance1ksz6yxlolvnl,
  TextButtonSemantic_getInstance as TextButtonSemantic_getInstance1oqfo0yth5rcj,
};
//endregion

//# sourceMappingURL=buttons.mjs.map
